import { create } from 'zustand';
import apiClient from '../utils/apiClient';

// Admin management of license_agreement rows + the per-user acceptance report.
// (The signed-in user's own agreement/acceptance lives in optInStore.license.)
export const useLicenseAgreementsStore = create((set) => ({
  agreements: [],
  status: [],
  statusSummary: {},
  isLoading: false,
  error: null,

  fetchAgreements: async () => {
    set({ isLoading: true, error: null });
    try {
      const rows = await apiClient.get('/license-agreement-list');
      set({ agreements: Array.isArray(rows) ? rows : [], isLoading: false });
    } catch (err) {
      set({ agreements: [], isLoading: false, error: err.message || 'Failed to fetch license agreements' });
    }
  },

  // Every user, the agreement that applies to them, and whether they've accepted it.
  fetchStatus: async () => {
    set({ isLoading: true, error: null });
    try {
      const res = await apiClient.post('/license-agreement-request', { type: 'status' });
      set({
        status: res?.records || [],
        statusSummary: res?.metadata?.agreements || {},
        isLoading: false,
      });
    } catch (err) {
      set({ status: [], statusSummary: {}, isLoading: false, error: err.message || 'Failed to fetch acceptance status' });
    }
  },

  // create/update/delete re-fetch the list: setting is_default on one row
  // clears it on the others server-side.
  addAgreement: async (agreement) => {
    const created = await apiClient.post('/license-agreement', agreement);
    await useLicenseAgreementsStore.getState().fetchAgreements();
    return created;
  },

  updateAgreement: async (id, agreement) => {
    const updated = await apiClient.put(`/license-agreement/${id}`, agreement);
    await useLicenseAgreementsStore.getState().fetchAgreements();
    return updated;
  },

  deleteAgreement: async (id) => {
    await apiClient.delete(`/license-agreement/${id}`);
    await useLicenseAgreementsStore.getState().fetchAgreements();
  },
}));
